<template>

    <div>

        <h2 class="pb-4">Network</h2>

        <div class="sau-bx bx-pad">
            <p>Want to know why you don't have any network statistics...?</p>
        </div>

    </div>
</template>

<script>
export default {
    props: ['service'],
    data() {
        return {
            showPorts: false,
        }
    },
    created() {
    },
    methods: {
    },
    computed: {
    }
}
</script>
